export default __webpack_public_path__ + "static/media/water.b6d13329.svg";